import { BottomActionsWrapper } from '@shared/components/ScheduleEditor/components/BottomActionsWrapper';
import { ButtonV2, ButtonV2Props } from '@withjoy/joykit';
import React, { ComponentProps, ReactNode } from 'react';

type BottomBarProps = {
  actions: {
    label: string;
    onClick?: () => void;
    variant?: 'primary' | 'secondary';
    buttonProps?: ButtonV2Props;
    hidden?: boolean;
  }[];
  containerProps?: ComponentProps<typeof BottomActionsWrapper>;
  children?: ReactNode;
};

const PRIMARY_PROPS: ButtonV2Props = {
  backgroundColor: '#fff',
  color: '#000',
  variant: 'outline',
  borderColor: 'mono5',
  borderWidth: '2px',
  _active: {
    backgroundColor: 'mono5',
    borderColor: 'mono7',
    color: 'mono14',
  },
  _hover: {
    backgroundColor: 'mono3',
    borderColor: 'mono6',
    color: 'mono12',
  },
};

const SECONDARY_PROPS: ButtonV2Props = {
  backgroundColor: '#000',
  borderColor: 'mono5',
  borderWidth: '2px',
  variant: 'solid',
  filter: 'drop-shadow(0px 7px 27px rgba(44, 41, 37, 0.06)) drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.07))',
  _active: {
    backgroundColor: 'mono14',
  },
  _hover: {
    backgroundColor: 'mono13',
  },
};

export const BottomBar = (props: BottomBarProps) => {
  const visibleCount = props.actions.filter(action => !action.hidden).length;

  return (
    <BottomActionsWrapper
      padding="1.5rem"
      height="6.5rem"
      gap="1.5rem"
      {...props.containerProps}
    >
      {props.actions.map((action, index) => {
        const variantProps = action.variant === 'secondary' ? SECONDARY_PROPS : action.variant === 'primary' ? PRIMARY_PROPS : {};
        const buttonProps = { ...variantProps, ...action.buttonProps };

        if (action.hidden) {
          return null;
        }

        return (
          <ButtonV2
            key={index}
            onClick={action.onClick}
            shape="rounded"
            height="56px"
            width={visibleCount === 1 ? '176px' : '100%'}
            paddingX="1.5rem"
            size="lg"
            zIndex={2}
            userSelect="none"
            {...buttonProps}
          >
            {action.label}
          </ButtonV2>
        );
      })}
      {props.children}
    </BottomActionsWrapper>
  );
};
